<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/AssetProducts'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เจ้าของทรัพย์สิน:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reApAssetOwner'"
                    :name="'reApAssetOwner'"
                    :select2-options="reApAssetOwnerOptions"
                    multiple
                    v-model="reApAssetOwner"
                    ref="reApAssetOwnerSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reApAssetOwner"
                    :multiple="true"
                    :options="reApAssetOwnerOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Book Value:</label>
                  <input
                    v-model="reApBookValue"
                    type="number"
                    class="form-control"
                    placeholder="กรุณาระบุ Book Value"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ผู้จำหน่าย(Supplier):</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reApVendor'"
                    :name="'reApVendor'"
                    :select2-options="reApVendorOptions"
                    multiple
                    v-model="reApVendor"
                    ref="reApVendorSelect2"
                  ></select2> -->

                  <treeselect
                    v-model="reApVendor"
                    :multiple="true"
                    :load-options="LoadreApVendorOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reApBarcodeStatusCode'"
                    :name="'reApBarcodeStatusCode'"
                    :select2-options="reApBarcodeStatusCodeOptions"
                    multiple
                    v-model="reApBarcodeStatusCode"
                    ref="reApBarcodeStatusCodeSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reApBarcodeStatusCode"
                    :multiple="true"
                    :options="reApBarcodeStatusCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เคลื่อนไหวล่าสุด(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reApLastActivityDateStart"
                      name="reApLastActivityDateStart"
                      ref="reApLastActivityDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เคลื่อนไหวล่าสุด(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reApLastActivityDateEnd"
                      name="reApLastActivityDateEnd"
                      ref="reApLastActivityDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่รับเข้า(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reApRetrieveDateStart"
                      name="reApRetrieveDateStart"
                      ref="reApRetrieveDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่รับเข้า(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reApRetrieveDateEnd"
                      name="reApRetrieveDateEnd"
                      ref="reApRetrieveDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!--Begin : Collap ค้นหาสินค้า-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <Collapsible class="product-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาสินค้า
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-plus-square"></i> ค้นหาสินค้า
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="product">
                    <div class="row">
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>หมวดหมู่สินค้า:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reApProductGroup'"
                            :name="'reApProductGroup'"
                            :select2-options="reApProductGroupOptions"
                            multiple
                            v-model="reApProductGroup"
                            ref="reApProductGroupSelect2"
                          ></select2> -->
                          <treeselect
                            v-model="reApProductGroup"
                            :multiple="true"
                            :options="reApProductGroupOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ประเภทสินค้า:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reApProductType'"
                            :name="'reApProductType'"
                            :select2-options="reApProductTypeOptions"
                            multiple
                            v-model="reApProductType"
                            ref="reApProductTypeSelect2"
                          ></select2> -->
                          <treeselect
                            v-model="reApProductType"
                            :multiple="true"
                            :options="reApProductTypeOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>สินค้า:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reApMaterialCode'"
                            :name="'reApMaterialCode'"
                            :select2-options="reApMaterialCodeOptions"
                            multiple
                            v-model="reApMaterialCode"
                            ref="reApMaterialCodeSelect2"
                          ></select2> -->
                          <treeselect
                            v-model="reApMaterialCode"
                            :multiple="true"
                            :options="reApMaterialCodeOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>แบรนด์สินค้า:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reApProductBrand'"
                            :name="'reApProductBrand'"
                            :select2-options="reApProductBrandOptions"
                            multiple
                            v-model="reApProductBrand"
                            ref="reApProductBrandSelect2"
                          ></select2> -->
                          <treeselect
                            v-model="reApProductBrand"
                            :multiple="true"
                            :options="reApProductBrandOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>อายุสินค้า(วัน):</label>
                          <input
                            v-model="reApAssetLifeTime"
                            type="number"
                            class="form-control"
                            placeholder="กรุณาระบุอายุสินค้า(วัน)"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันหมดอายุสินค้า(เริ่มต้น):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reApEndOfLifeDateStart"
                              name="reApEndOfLifeDateStart"
                              ref="reApEndOfLifeDateStart"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันหมดอายุสินค้า(สิ้นสุด):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reApEndOfLifeDateEnd"
                              name="reApEndOfLifeDateEnd"
                              ref="reApEndOfLifeDateEnd"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ราคา/หน่วย:</label>
                          <input
                            v-model="reApPricing"
                            type="number"
                            class="form-control"
                            placeholder="กรุณาระบุราคา/หน่วย"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหาสินค้า-->

              <!--Begin : Collap ค้นหารหัส-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <Collapsible class="code-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหารหัส
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-plus-square"></i> ค้นหารหัส
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="code">
                    <div class="row">
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>BARCODE:</label>
                          <input
                            v-model="reApBarcodeNoOld"
                            type="text"
                            class="form-control"
                            placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>รหัสทรัพย์สิน(เบียร์สด):</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reApDepartmentMaterial'"
                            :name="'reApDepartmentMaterial'"
                            :select2-options="reApDepartmentMaterialOptions"
                            multiple
                            v-model="reApDepartmentMaterial"
                            ref="reApDepartmentMaterialSelect2"
                          ></select2> -->
                          <treeselect
                            v-model="reApDepartmentMaterial"
                            :multiple="true"
                            :load-options="LoadreApDepartmentMaterialOptions"
                            :async="true"
                            v-on:select="ClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="false"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>รหัสทรัพย์สิน(บัญชี):</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reApAccountMaterial'"
                            :name="'reApAccountMaterial'"
                            :select2-options="reApAccountMaterialOptions"
                            multiple
                            v-model="reApAccountMaterial"
                            ref="reApAccountMaterialSelect2"
                          ></select2> -->
                          <treeselect
                            v-model="reApAccountMaterial"
                            :multiple="true"
                            :load-options="LoadreApAccountMaterialOptions"
                            :async="true"
                            v-on:select="ClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="false"
                          />
                        </div>
                      </div>

                    </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหารหัส-->

              <!--Begin : Collap ค้นหาประกัน-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <Collapsible class="warranty-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาประกัน
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-plus-square"></i> ค้นหาประกัน
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="warranty">
                    <div class="row">
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>จำนวนวันที่รับประกัน (วัน):</label>
                          <input
                            v-model="reApWarrantyTime"
                            type="number"
                            class="form-control"
                            placeholder="กรุณาระบุจำนวนวันที่รับประกัน (วัน)"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันสิ้นสุดการรับประกัน(เริ่มต้น):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reApWarrantyEndDateStart"
                              name="reApWarrantyEndDateStart"
                              ref="reApWarrantyEndDateStart"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันสิ้นสุดการรับประกัน(สิ้นสุด):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reApWarrantyEndDateEnd"
                              name="reApWarrantyEndDateEnd"
                              ref="reApWarrantyEndDateEnd"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>สถานะการประกัน:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reApWarrantyStatus'"
                            :name="'reApWarrantyStatus'"
                            :select2-options="reApWarrantyStatusOptions"
                            multiple
                            v-model="reApWarrantyStatus"
                            ref="reApWarrantyStatusSelect2"
                          ></select2> -->
                          <treeselect
                            v-model="reApWarrantyStatus"
                            :multiple="true"
                            :options="reApWarrantyStatusOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันที่รับประกัน(หลังการซ่อม)(เริ่มต้น):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reApRepairWarrantyDateStart"
                              name="reApRepairWarrantyDateStart"
                              ref="reApRepairWarrantyDateStart"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันที่รับประกัน(หลังการซ่อม)(สิ้นสุด):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reApRepairWarrantyDateEnd"
                              name="reApRepairWarrantyDateEnd"
                              ref="reApRepairWarrantyDateEnd"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหาประกัน-->
            </div>

            <div class="row mb-3" v-if="this.$root.canShow(['BR_REPORT', 'SUB_AGENT_REPORT'])">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportAssetProduct"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="assetProductTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="26">
                      ข้อมูล ณ วันที่ {{ reApDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">เจ้าของทรัพย์สิน</th>
                    <th class="all text-center">หมวดหมู่สินค้า</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">สถานะ</th>
                    <th class="all text-center">BARCODE</th>
                    <th class="all text-center">รหัสทรัพย์สิน(เบียร์สด)</th>
                    <th class="all text-center">รหัสทรัพย์สิน(บัญชี)</th>
                    <th class="all text-center">ราคา/หน่วย</th>
                    <th class="all text-center">จำนวน</th>
                    <th class="all text-center">ราคารวม</th>
                    <th class="all text-center">วันที่รับเข้า</th>
                    <th class="all text-center">จำนวนวันที่รับประกัน (วัน)</th>
                    <th class="all text-center">วันสิ้นสุดการรับประกัน</th>
                    <th class="all text-center">สถานะการประกัน</th>
                    <th class="all text-center">
                      วันที่รับประกัน(หลังการซ่อม)
                    </th>
                    <th class="all text-center">อายุสินค้า (วัน)</th>
                    <th class="all text-center">วันหมดอายุสินค้า</th>
                    <th class="all text-center">Book Value</th>
                    <th class="all text-center">ผู้จำหน่าย (Supplier)</th>
                    <th class="all text-center">วันที่เคลื่อนไหวล่าสุด</th>
                  </tr>
                </thead>
                <!-- <tfoot >
                  <tr>
                      <th class="text-right" colspan="6">จำนวนรวม</th>
                      <th class="text-center">{{TotalAmount}}</th>
                      <th colspan="5"></th>
                  </tr>
              </tfoot> -->
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
//import "vue-collapsible-component/lib/vue-collapsible.css";
import Collapsible from "../../Shared/Collapsible"; //"vue-collapsible-component";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Collapsible,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reApIsInitial: true,
      reApDateReq: null,
      reApAssetOwner: [],
      reApProductGroup: [],
      reApProductType: [],
      reApMaterialCode: [],
      reApProductBrand: [],
      reApBarcodeStatusCode: [],
      reApLastActivityDateStart: null,
      reApLastActivityDateEnd: null,
      reApBarcodeNo: null,
      reApBarcodeNoOld: null,
      reApDepartmentMaterial: [],
      reApAccountMaterial: [],
      reApNFCCode: [],
      reApPricing: null,
      reApRetrieveDateStart: null,
      reApRetrieveDateEnd: null,
      reApWarrantyTime: null,
      reApWarrantyEndDateStart: null,
      reApWarrantyEndDateEnd: null,
      reApWarrantyStatus: [],
      reApRepairWarrantyDateStart: null,
      reApRepairWarrantyDateEnd: null,
      reApAssetLifeTime: null,
      reApEndOfLifeDateStart: null,
      reApEndOfLifeDateEnd: null,
      reApBookValue: null,
      reApVendor: [],
      reApAssetOwnerOptions: [],
      // reApAssetOwnerOptions: {
      //   placeholder: "กรุณาเลือกเจ้าของทรัพย์สิน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/MasterAssetOwner/Select2AssetOwner",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApProductGroupOptions: [],
      // reApProductGroupOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApProductTypeOptions: [],
      // reApProductTypeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApMaterialCodeOptions: [],
      // reApMaterialCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApProductBrandOptions: [],
      // reApProductBrandOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApBarcodeStatusCodeOptions: [],
      // reApBarcodeStatusCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApBarcodeNoOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2Barcode",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reApBarcodeNoOldOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกรหัส BARCODE",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeOld",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reApDepartmentMaterialOptions: [],
      // reApDepartmentMaterialOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสทรัพย์สิน(เบียร์สด)",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2DepartmentMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApAccountMaterialOptions: [],
      // reApAccountMaterialOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัสทรัพย์สิน(บัญชี)",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2AccountMaterial",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApNFCCodeOptions: [],
      // reApNFCCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกรหัส NFC",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Barcode/Select2NFC",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reApWarrantyStatusOptions: [
        { id: "อยู่ในประกัน", label: "อยู่ในประกัน" },
        { id: "หมดประกัน", label: "หมดประกัน" },
      ],

      // reApWarrantyStatusOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะการประกัน",
      //   allowClear: true,
      //   data: [
      //     { id: "อยู่ในประกัน", text: "อยู่ในประกัน", data: null },
      //     { id: "หมดประกัน", text: "หมดประกัน", data: null },
      //   ],
      // },
      reApVendorOptions: [],
      // reApVendorOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกผู้จำหน่าย(Supplier)",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Vendors/Select2Vendor",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formReset: function(e) {
      let self = this;
      (self.reAp1 = []),
        (self.reApProductGroup = []),
        (self.reApProductType = []),
        (self.reApMaterialCode = []),
        (self.reApProductBrand = []),
        (self.reApBarcodeStatusCode = []),
        (self.reApLastActivityDateStart = null),
        (self.reApLastActivityDateEnd = null),
        (self.reApBarcodeNo = null),
        (self.reApBarcodeNoOld = null),
        (self.reApDepartmentMaterial = []),
        (self.reApAccountMaterial = []),
        (self.reApNFCCode = []),
        (self.reApPricing = null),
        (self.reApRetrieveDateStart = null),
        (self.reApRetrieveDateEnd = null),
        (self.reApWarrantyTime = null),
        (self.reApWarrantyEndDateStart = null),
        (self.reApWarrantyEndDateEnd = null),
        (self.reApWarrantyStatus = []),
        (self.reApRepairWarrantyDateStart = null),
        (self.reApRepairWarrantyDateEnd = null),
        (self.reApAssetLifeTime = null),
        (self.reApEndOfLifeDateStart = null),
        (self.reApEndOfLifeDateEnd = null),
        (self.reApBookValue = null),
        (self.reApVendor = []),
        (self.reApAssetOwner = []);
      $("#reApAssetOwner")
        .val("")
        .trigger("change");

      $("#reApProductGroup")
        .val("")
        .trigger("change");

      $("#reApProductType")
        .val("")
        .trigger("change");

      $("#reApMaterialCode")
        .val("")
        .trigger("change");

      $("#reApProductBrand")
        .val("")
        .trigger("change");

      $("#reApBarcodeStatusCode")
        .val("")
        .trigger("change");

      $("#reApBarcodeNoOld")
        .val("")
        .trigger("change");

      $("#reApDepartmentMaterial")
        .val("")
        .trigger("change");

      $("#reApAccountMaterial")
        .val("")
        .trigger("change");

      $("#reApWarrantyStatus")
        .val("")
        .trigger("change");

      $("#reApVendor")
        .val("")
        .trigger("change");
    },
    formSubmit: function(e) {
      let self = this;

      if (e.submitter.innerText != "Generate Report") {
        return false;
      }

      // วันที่เคลื่อนไหวล่าสุด
      if (!self.reApLastActivityDateStart && self.reApLastActivityDateEnd) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันที่เคลื่อนไหวล่าสุด(เริ่มต้น)",
          "warning"
        );
        return false;
      } else if (
        self.reApLastActivityDateStart &&
        !self.reApLastActivityDateEnd
      ) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันที่เคลื่อนไหวล่าสุด(สิ้นสุด)",
          "warning"
        );
        return false;
      }

      // วันที่รับเข้า

      if (!self.reApRetrieveDateStart && self.reApRetrieveDateEnd) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันที่รับเข้า(เริ่มต้น)",
          "warning"
        );
        return false;
      } else if (self.reApRetrieveDateStart && !self.reApRetrieveDateEnd) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันที่รับเข้า(สิ้นสุด)",
          "warning"
        );
        return false;
      }

      // วันหมดอายุสินค้า
      if (!self.reApEndOfLifeDateStart && self.reApEndOfLifeDateEnd) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันหมดอายุสินค้า(เริ่มต้น)",
          "warning"
        );
        return false;
      } else if (self.reApEndOfLifeDateStart && !self.reApEndOfLifeDateEnd) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันหมดอายุสินค้า(สิ้นสุด)",
          "warning"
        );
        return false;
      }

      // วันสิ้นสุดการรับประกัน

      if (!self.reApWarrantyEndDateStart && self.reApWarrantyEndDateEnd) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันสิ้นสุดการรับประกัน(เริ่มต้น)",
          "warning"
        );
        return false;
      } else if (
        self.reApWarrantyEndDateStart &&
        !self.reApWarrantyEndDateEnd
      ) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันสิ้นสุดการรับประกัน(สิ้นสุด)",
          "warning"
        );
        return false;
      }

      // วันที่รับประกัน

      if (!self.reApRepairWarrantyDateStart && self.reApRepairWarrantyDateEnd) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันที่รับประกัน(หลังการซ่อม)(เริ่มต้น)",
          "warning"
        );
        return false;
      } else if (
        self.reApRepairWarrantyDateStart &&
        !self.reApRepairWarrantyDateEnd
      ) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกวันที่รับประกัน(หลังการซ่อม)(สิ้นสุด)",
          "warning"
        );
        return false;
      }

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      let status = null;

      e.preventDefault();
      var table = $("#assetProductTable").DataTable();
      table.draw();
    },
    exportAssetProduct: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportAssetProducts",
        responseType: "arraybuffer",
        data: {
          AssetOwnerId: self.reApAssetOwner,
          ProductGroupId: self.reApProductGroup,
          ProductTypeId: self.reApProductType,
          MaterialCode: self.reApMaterialCode,
          ProductBrandId: self.reApProductBrand,
          BarcodeStatusCode: self.reApBarcodeStatusCode,
          LastActivityDateStart:
            self.reApLastActivityDateStart != null
              ? self.reApLastActivityDateStart.format("DD/MM/YYYY")
              : null,
          LastActivityDateEnd:
            self.reApLastActivityDateEnd != null
              ? self.reApLastActivityDateEnd.format("DD/MM/YYYY")
              : null,
          BarcodeNo: self.reApBarcodeNo,
          BarcodeNoOld: self.reApBarcodeNoOld,
          DepartmentMaterialCode: self.reApDepartmentMaterial,
          AccountMaterialCode: self.reApAccountMaterial,
          NFCCode: self.reApNFCCode,
          Pricing: self.reApPricing,
          RetrieveDateStart:
            self.reApRetrieveDateStart != null
              ? self.reApRetrieveDateStart.format("DD/MM/YYYY")
              : null,
          RetrieveDateEnd:
            self.reApRetrieveDateEnd != null
              ? self.reApRetrieveDateEnd.format("DD/MM/YYYY")
              : null,
          WarrantyTime: self.reApWarrantyTime,
          WarrantyEndDateStart:
            self.reApWarrantyEndDateStart != null
              ? self.reApWarrantyEndDateStart.format("DD/MM/YYYY")
              : null,
          WarrantyEndDateEnd:
            self.reApWarrantyEndDateEnd != null
              ? self.reApWarrantyEndDateEnd.format("DD/MM/YYYY")
              : null,
          WarrantyStatus: self.reApWarrantyStatus,
          RepairWarrantyDateStart:
            self.reApRepairWarrantyDateStart != null
              ? self.reApRepairWarrantyDateStart.format("DD/MM/YYYY")
              : null,
          RepairWarrantyDateEnd:
            self.reApRepairWarrantyDateEnd != null
              ? self.reApRepairWarrantyDateEnd.format("DD/MM/YYYY")
              : null,
          AssetLifeTime: self.reApAssetLifeTime,
          EndOfLifeDateStart:
            self.reApEndOfLifeDateStart != null
              ? self.reApEndOfLifeDateStart.format("DD/MM/YYYY")
              : null,
          EndOfLifeDateEnd:
            self.reApEndOfLifeDateEnd != null
              ? self.reApEndOfLifeDateEnd.format("DD/MM/YYYY")
              : null,
          BookValue: self.reApBookValue,
          VendorId: self.reApVendor,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    openCollap: function(e) {
      var coll = document.getElementsByClassName("collapsible");
      var i;

      for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function() {
          this.classList.toggle("active");
          var content = this.nextElementSibling;
          if (content.style.display === "block") {
            content.style.display = "none";
          } else {
            content.style.display = "block";
          }
        });
      }
    },
    LoadreApAssetOwnerOptions: function(e) {
      var self = this;
      axios
        .get("/Api/MasterAssetOwner/Select2AssetOwner", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reApAssetOwnerOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreApProductGroupOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductGroup/Select2ProductGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reApProductGroupOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreApProductTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reApProductTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreApMaterialCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reApMaterialCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreApProductBrandOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reApProductBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreApBarcodeStatusCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reApBarcodeStatusCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreApDepartmentMaterialOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reApDepartmentMaterialOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2DepartmentMaterial", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reApDepartmentMaterialOptions = [];
              data.forEach((element) => {
                self.reApDepartmentMaterialOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reApDepartmentMaterialOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreApAccountMaterialOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reApAccountMaterialOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2AccountMaterial", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reApAccountMaterialOptions = [];
              data.forEach((element) => {
                self.reApAccountMaterialOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reApAccountMaterialOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreApNFCCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reApNFCCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2NFC", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reApNFCCodeOptions = [];
              data.forEach((element) => {
                self.reApNFCCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reApNFCCodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreApVendorOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reApVendorOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Vendors/Select2Vendor", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reApVendorOptions = [];
              data.forEach((element) => {
                self.reApVendorOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reApVendorOptions);
          })
          .catch(function(error) {});
      }
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;
    self.LoadreApAssetOwnerOptions();
    self.LoadreApProductGroupOptions();
    self.LoadreApProductTypeOptions();
    self.LoadreApMaterialCodeOptions();
    self.LoadreApProductBrandOptions();
    self.LoadreApBarcodeStatusCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reApDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reApLastActivityDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateStart = moment().set("date",1);
    $(self.$refs.reApLastActivityDateStart)
      .datepicker(
        "update",
        !!self.reApLastActivityDateStart
          ? self.reApLastActivityDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reApLastActivityDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reApLastActivityDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reApLastActivityDateEnd)
      .datepicker(
        "update",
        !!self.reApLastActivityDateEnd
          ? self.reApLastActivityDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reApLastActivityDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reApRetrieveDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApRetrieveDateStart = moment().set("date",1);
    $(self.$refs.reApRetrieveDateStart)
      .datepicker(
        "update",
        !!self.reApRetrieveDateStart
          ? self.reApRetrieveDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        //self.reApRetrieveDateStart = moment(e.date);
        self.reApRetrieveDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reApRetrieveDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApRetrieveDateEnd = moment().endOf('month');
    $(self.$refs.reApRetrieveDateEnd)
      .datepicker(
        "update",
        !!self.reApRetrieveDateEnd
          ? self.reApRetrieveDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        //self.reApRetrieveDateEnd = moment(e.date);
        self.reApRetrieveDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reApWarrantyEndDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApWarrantyEndDateStart = moment().set("date",1);
    $(self.$refs.reApWarrantyEndDateStart)
      //.datepicker("update", (self.reApWarrantyEndDateStart != null) ? self.reApWarrantyEndDateStart.format("DD/MM/YYYY") : null)
      .on("changeDate", function(e) {
        //self.reApWarrantyEndDateStart = moment(e.date);
        self.reApWarrantyEndDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reApWarrantyEndDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApWarrantyEndDateEnd = moment().endOf('month');
    $(self.$refs.reApWarrantyEndDateEnd)
      //.datepicker("update", (self.reApWarrantyEndDateEnd != null) ? self.reApWarrantyEndDateEnd.format("DD/MM/YYYY") : null)
      .on("changeDate", function(e) {
        //self.reApWarrantyEndDateEnd = moment(e.date);
        self.reApWarrantyEndDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reApRepairWarrantyDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApRepairWarrantyDateStart = moment().set("date",1);
    $(self.$refs.reApRepairWarrantyDateStart)
      .datepicker(
        "update",
        !!self.reApRepairWarrantyDateStart
          ? self.reApRepairWarrantyDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        //self.reApRepairWarrantyDateStart = moment(e.date);
        self.reApRepairWarrantyDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reApRepairWarrantyDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApRepairWarrantyDateEnd = moment().endOf('month');
    $(self.$refs.reApRepairWarrantyDateEnd)
      .datepicker(
        "update",
        !!self.reApRepairWarrantyDateEnd
          ? self.reApRepairWarrantyDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        //self.reApRepairWarrantyDateEnd = moment(e.date);
        self.reApRepairWarrantyDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reApEndOfLifeDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApEndOfLifeDateStart = moment().set("date",1);
    $(self.$refs.reApEndOfLifeDateStart)
      .datepicker(
        "update",
        !!self.reApEndOfLifeDateStart
          ? self.reApEndOfLifeDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        //self.reApEndOfLifeDateStart = moment(e.date);
        self.reApEndOfLifeDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reApEndOfLifeDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApEndOfLifeDateEnd = moment().endOf('month');
    $(self.$refs.reApEndOfLifeDateEnd)
      .datepicker(
        "update",
        !!self.reApEndOfLifeDateEnd
          ? self.reApEndOfLifeDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        //self.reApEndOfLifeDateEnd = moment(e.date);
        self.reApEndOfLifeDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#assetProductTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/AssetProducts",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              IsInitial: self.reApIsInitial,
              AssetOwnerId: self.reApAssetOwner,
              ProductGroupId: self.reApProductGroup,
              ProductTypeId: self.reApProductType,
              MaterialCode: self.reApMaterialCode,
              ProductBrandId: self.reApProductBrand,
              BarcodeStatusCode: self.reApBarcodeStatusCode,
              LastActivityDateStart:
                self.reApLastActivityDateStart != null
                  ? self.reApLastActivityDateStart.format("DD/MM/YYYY")
                  : null,
              LastActivityDateEnd:
                self.reApLastActivityDateEnd != null
                  ? self.reApLastActivityDateEnd.format("DD/MM/YYYY")
                  : null,
              BarcodeNo: self.reApBarcodeNo,
              BarcodeNoOld: self.reApBarcodeNoOld,
              DepartmentMaterialCode: self.reApDepartmentMaterial,
              AccountMaterialCode: self.reApAccountMaterial,
              NFCCode: self.reApNFCCode,
              Pricing: self.reApPricing,
              RetrieveDateStart:
                self.reApRetrieveDateStart != null
                  ? self.reApRetrieveDateStart.format("DD/MM/YYYY")
                  : null,
              RetrieveDateEnd:
                self.reApRetrieveDateEnd != null
                  ? self.reApRetrieveDateEnd.format("DD/MM/YYYY")
                  : null,
              WarrantyTime: self.reApWarrantyTime,
              WarrantyEndDateStart:
                self.reApWarrantyEndDateStart != null
                  ? self.reApWarrantyEndDateStart.format("DD/MM/YYYY")
                  : null,
              WarrantyEndDateEnd:
                self.reApWarrantyEndDateEnd != null
                  ? self.reApWarrantyEndDateEnd.format("DD/MM/YYYY")
                  : null,
              WarrantyStatus: self.reApWarrantyStatus,
              RepairWarrantyDateStart:
                self.reApRepairWarrantyDateStart != null
                  ? self.reApRepairWarrantyDateStart.format("DD/MM/YYYY")
                  : null,
              RepairWarrantyDateEnd:
                self.reApRepairWarrantyDateEnd != null
                  ? self.reApRepairWarrantyDateEnd.format("DD/MM/YYYY")
                  : null,
              AssetLifeTime: self.reApAssetLifeTime,
              EndOfLifeDateStart:
                self.reApEndOfLifeDateStart != null
                  ? self.reApEndOfLifeDateStart.format("DD/MM/YYYY")
                  : null,
              EndOfLifeDateEnd:
                self.reApEndOfLifeDateEnd != null
                  ? self.reApEndOfLifeDateEnd.format("DD/MM/YYYY")
                  : null,
              BookValue: self.reApBookValue,
              VendorId: self.reApVendor,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[0, "desc"]],
        columns: [
          {
            data: "lastActivityDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "assetOwnerName", className: "text-center" },
          { data: "productGroupName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "materialCode", className: "text-center" },
          { data: "materialName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
          { data: "barcodeStatusName", className: "text-center" },
          { data: "barcodeNoOld", className: "text-center" },
          { data: "departmentMaterialCode", className: "text-center" },
          { data: "accountMaterialCode", className: "text-center" },
          {
            data: "pricing",
            className: "text-center",
            render: function(data, type, full, meta) {
              return self.$options.filters.currency(data, "฿");
            },
          },
          {
            data: "quantity",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "amount",
            className: "text-center",
            render: function(data, type, full, meta) {
              return self.$options.filters.currency(data, "฿");
            },
          },
          {
            data: "retrieveDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.retrieveDateString;
            },
          },
          {
            data: "warrantyTime",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null && data != "" && data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "warrantyEndDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.warrantyEndDateString;
            },
          },
          { data: "warrantyStatus", className: "text-center" },
          {
            data: "repairWarrantyDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.repairWarrantyDateString;
            },
          },
          {
            data: "assetLifeTime",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null && data != "" && data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "endOfLifeDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.endOfLifeDateString;
            },
          },
          {
            data: "bookValue",
            className: "text-center",
            render: function(data, type, full, meta) {
              return self.$options.filters.currency(data, "฿");
            },
          },
          { data: "vendorName", className: "text-center" },
          {
            data: "lastActivityDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.lastActivityDateString;
            },
          },
        ],
        rowCallback: function(row, data, index) {
          if (data.warrantyStatus == "หมดประกัน") {
            $(row)
              .find("td:eq(19)")
              .css("color", "white");
            $(row)
              .find("td:eq(19)")
              .css("background-color", "#EB355E");
          }
        },
        drawCallback: function(settings) {
          self.reApIsInitial = false;
          self.reApDateReq = moment().format("DD/MM/YYYY h:mm a");
        },
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped>
/* Style the button that is used to open and close the collapsible content */
.collapsible {
  background-color: #eee;
  color: #444;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
}

/* Add a background color to the button if it is clicked on (add the .active class with JS), and when you move the mouse over it (hover) */
.active,
.collapsible:hover {
  background-color: #ccc;
}

/* Style the collapsible content. Note: hidden by default */
.content {
  padding: 0 18px;
  display: none;
  overflow: hidden;
  background-color: #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// App/Components/Report/AssetProducts.vue